import { createIcon } from '@chakra-ui/icons';

export const Pencil = createIcon({
  displayName: 'Pencil',
  viewBox: '0 0 12 12',
  path: [
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_915_4348)">
        <path
          d="M8.78044 0.220078C8.6398 0.0794748 8.44907 0.000488281 8.25019 0.000488281C8.05132 0.000488281 7.86059 0.0794748 7.71994 0.220078L0.969942 6.97008C0.865886 7.07401 0.794684 7.20624 0.765192 7.35033L0.0151924 11.1003C-0.00964081 11.2218 -0.00396095 11.3476 0.0317236 11.4663C0.0674081 11.5851 0.131984 11.6932 0.21967 11.7809C0.307356 11.8685 0.415417 11.9331 0.534178 11.9688C0.65294 12.0045 0.778697 12.0102 0.900192 11.9853L4.65019 11.2353C4.79535 11.2064 4.92869 11.1351 5.03344 11.0306L11.7834 4.28058C11.924 4.13993 12.003 3.9492 12.003 3.75033C12.003 3.55146 11.924 3.36072 11.7834 3.22008L8.78044 0.220078ZM4.13044 9.80958L1.70569 10.2948L2.19094 7.87008L6.00019 4.06083L7.93969 6.00033L4.13044 9.80958ZM9.00019 4.93983L7.06069 3.00033L8.25019 1.81083L10.1897 3.75033L9.00019 4.93983Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_915_4348">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
